export default __webpack_public_path__ + "static/media/480_dummy2016-schmuck01-de-mobile.891c7803.png";